import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Select } from 'SRC/ui/FormElements'

export const BirthDate = () => {
  const { t } = useTranslation('common')

  const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
  const months = [
    t('Januar'), t('Februar'), t('Mart'), t('April'), t('Maj'), t('Jun'), t('Jul'),
    t('Avgust'), t('Septembar'), t('Oktobar'), t('Novembar'), t('Decembar')
  ]

  const getYears = () => {
    const years = []
    const end = 1900
    for (let start = new Date().getFullYear(); start >= end; start--) {
      years.push(start)
    }
    return years
  }

  const getDayField = () => ({
    id: 'day',
    name: 'day',
    options: days.map((day, index) => ({
      id: index,
      label: `${day}`,
      value: day,
      isDisabled: false
    })),
    label: '',
    labelDefault: t('dan'),
    needColon: false
  })

  const getMonthField = () => ({
    id: 'month',
    name: 'month',
    options: months.map((month, index) => ({
      id: index,
      label: month,
      value: index,
      isDisabled: false
    })),
    label: '',
    labelDefault: t('Mjesec'),
    needColon: false
  })

  const getYearField = () => ({
    id: 'year',
    name: 'year',
    options: getYears().map((year, index) => ({
      id: index,
      label: `${year}`,
      value: year,
      isDisabled: false
    })),
    label: '',
    labelDefault: t('Godina'),
    needColon: false
  })

  const dayField = getDayField()
  const monthField = getMonthField()
  const yearField = getYearField()

  return (
    <div className='form-datum-rodjenja'>
      <label>{t('Datum rođenja')}:</label>
      <Select {...dayField} />
      <Select {...monthField} />
      <Select {...yearField} />
    </div>
  )
}
